// L'anglais est la source de référence. `Dict` dans ./types en découle,
// donc fr/de/ar ne compilent pas si une clé manque ou est mal orthographiée.
const fr = {
  brand: { name: "SkillSynergy", first: "Skill", second: "Synergy" },

  nav: {
    courses: "Cours",
    pricing: "Tarifs",
    about: "À propos",
    contact: "Contact",
    bookCall: "Réserver un appel gratuit",
    openMenu: "Ouvrir le menu",
    closeMenu: "Fermer le menu",
    language: "Langue",
    skipToContent: "Aller au contenu",
  },

  cta: {
    exploreCourses: "Découvrir les cours",
    bookConsultation: "Réserver une consultation gratuite",
    scheduleConsultation: "Planifier une consultation gratuite",
    viewCourse: "Voir le cours",
    viewAll: "Tout voir",
    comparePlans: "Comparer toutes les formules",
    getInTouch: "Nous contacter",
    enrollNow: "S'inscrire",
    seePricing: "Voir les tarifs",
    purchaseNow: "Acheter",
    contactUs: "Nous contacter",
    done: "Terminé",
  },

  footer: {
    tagline:
      "Des cours de programmation en direct et pratiques, pour tous les niveaux.",
    coursesHeading: "Cours",
    contactHeading: "Nous contacter",
    contactBody:
      "Une question sur un cours ? Nous répondons généralement sous un jour ouvré.",
    copyright: (year: number) =>
      `Copyright © ${year} SkillSynergy. Tous droits réservés.`,
    terms: "Conditions générales",
    privacy: "Politique de confidentialité",
    imprint: "Mentions légales",
    cookieSettings: "Paramètres des cookies",
    socialLabel: (network: string) => `SkillSynergy sur ${network}`,
  },

  booking: {
    eyebrow: "Consultation gratuite",
    title: "Définissons votre parcours en 30 minutes",
    body: "Sans engagement et sans frais. Nous évaluons votre niveau et vous recommandons le cours et le rythme qui vous conviennent.",
    benefits: [
      "Un plan d'apprentissage adapté à vos objectifs",
      "Les conseils d'un instructeur expert",
      "Des réponses sur les tarifs, le calendrier et le format",
    ],
    formTitle: "Réservez votre appel gratuit",
    fullName: "Nom complet",
    fullNamePlaceholder: "Marie Dupont",
    email: "E-mail",
    emailPlaceholder: "marie@email.com",
    courseOfInterest: "Cours qui vous intéresse",
    notSureYet: "Je ne sais pas encore",
    preferredTrack: "Rythme préféré",
    bestTime: "Meilleur moment pour appeler",
    times: { morning: "Matin", afternoon: "Après-midi", evening: "Soir" },
    submit: "Demander mon appel gratuit",
    submitting: "Envoi…",
    disclaimer:
      "Nous ne partagerons jamais vos coordonnées. Réponse sous un jour ouvré.",
    successTitle: "Demande reçue",
    successBody:
      "Merci, nous vous écrirons sous un jour ouvré pour confirmer votre consultation gratuite.",
    close: "Fermer",
    error: "L'envoi a échoué. Veuillez réessayer ou nous écrire directement.",
  },

  form: {
    required: "Ce champ est obligatoire.",
    invalidEmail: "Saisissez une adresse e-mail valide.",
    consentLabel: "J'ai lu et j'accepte la",
    consentLink: "politique de confidentialité",
    consentSuffix:
      "et je consens à l'utilisation de mes coordonnées pour répondre à ma demande.",
    consentRequired:
      "Veuillez accepter la politique de confidentialité pour continuer.",
    rateLimited:
      "Vous avez déjà envoyé ce message plusieurs fois. Merci de patienter un peu avant de réessayer.",
  },

  consent: {
    title: "Nous respectons votre vie privée",
    body: "Nous utilisons des cookies strictement nécessaires au fonctionnement de ce site. Avec votre accord, nous aimerions aussi collecter des rapports d'erreurs anonymes pour corriger les bugs plus vite. Vous pouvez changer d'avis à tout moment.",
    acceptAll: "Tout accepter",
    rejectAll: "Refuser le non-essentiel",
    save: "Enregistrer mes choix",
    customise: "Personnaliser",
    privacyLink: "Politique de confidentialité",
    imprintLink: "Mentions légales",
    categories: {
      necessary: {
        title: "Strictement nécessaires",
        body: "Indispensables au fonctionnement du site : votre langue, vos choix de cookies et la sécurité de base. Ils ne quittent jamais nos serveurs.",
        always: "Toujours actifs",
      },
      analytics: {
        title: "Rapport d'erreurs",
        body: "Charge Sentry, qui signale les plantages et les erreurs pour que nous puissions les corriger. Il reçoit votre adresse IP et les détails de votre navigateur.",
      },
    },
  },

  a11y: {
    previous: "Précédent",
    next: "Suivant",
    breadcrumb: "Fil d'Ariane",
    home: "Accueil",
    newTab: "ouvre dans un nouvel onglet",
  },
};

export default fr;
